<ax-apple-wallet-button
  [walletResult]="alistWallet$ | async"
  [fileName]="alistName ? alistName : alistId"
></ax-apple-wallet-button>
